import { Stage } from 'application/stage'
import { CarDetailsCard } from 'features/car-details-card/components'
import { CarDetailProps } from 'features/car-details-card/types'
import React, { createContext, useContext } from 'react'

export const carDetailsCardContext = createContext<CarDetailProps>({} as CarDetailProps)

export const useCarDetailsCardConfig = () => useContext(carDetailsCardContext)

const CarDetailsCardProvider = carDetailsCardContext.Provider

export const CarDetails: Stage<CarDetailProps> = (props) => (
  <CarDetailsCardProvider value={props}>
    <CarDetailsCard />
  </CarDetailsCardProvider>
)

export default CarDetails
